import React from 'react'

const HERO_IMAGES = {
  about:    '/images/about-hero.jpeg',
  programs: '/images/programs-hero.jpeg',
  impact:   '/images/impact-hero.jpeg',
  donate:   '/images/hero-donate.jpeg',
  involved: '/images/hero-involved.jpeg',
  contact:  '/images/hero-contact.jpeg',
  default:  '/images/hero-default.jpeg',
}

export default function PageHero({ title, subtitle, variant = 'default', fadeClass = '' }) {
  const img = HERO_IMAGES[variant] || HERO_IMAGES.default

  return (
    <section className={`page-hero ${fadeClass}`}>
      <div
        className="page-hero-bg"
        style={{ backgroundImage: `url('${img}')` }}
        aria-hidden="true"
      ></div>
      <div className="page-hero-overlay" aria-hidden="true"></div>

      <div className="page-hero-content">
        <span className="eyebrow">SISDI</span>
        <h1 className="page-title">{title}</h1>
        {subtitle && <p className="lead">{subtitle}</p>}
      </div>
    </section>
  )
}
